var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleLogoBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83998 11.875C-0.12002 7.96498 1.44998 3.20498 5.35998 1.24498C6.45998 0.694976 7.67998 0.404976 8.90998 0.404976C10.88 0.384976 12.78 1.11498 14.21 2.46498L11.95 4.72498C11.13 3.94498 10.04 3.51498 8.90998 3.53498C6.87998 3.55498 5.08998 4.87498 4.46998 6.80498C4.13998 7.78498 4.13998 8.85498 4.46998 9.83498C5.31998 12.345 8.03998 13.695 10.55 12.855C10.92 12.735 11.28 12.565 11.6 12.345C12.43 11.795 13.01 10.925 13.18 9.93497H8.90998V6.88498H16.38C16.47 7.41498 16.52 7.95498 16.52 8.49498C16.59 10.685 15.74 12.795 14.16 14.315C12.72 15.595 10.84 16.285 8.90998 16.225C5.91998 16.235 3.18998 14.555 1.83998 11.875Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleLogoBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google_logo_blue.9ad53ffa34973fd99a18232ce7043740.svg";